<template>
  <div class="index">
    <!-- {{props}} -->
    <!-- 这是测试标题 -->
    <div class="out">
      <div class="title">{{ title }}</div>
    </div>
    <div style="margin-left: 26px">
      <div class="tabList">
        <div
          v-for="(item, index) in tabList"
          @click="change(item)"
          :class="activeItem == index ? 'active' : 'taber'"
          :index="index"
          :key="index"
        >
          {{ item.name }}({{ item.num }})
        </div>
      </div>

      <div
        class="list"
        v-for="(item, index) in list"
        :key="index"
        @click="toprojectList(item.id)"
      >
        <!-- <div
          class="listers"
          v-if="item.ischange"
          :style="{
            'border-bottom':
              index == 8 ? 'none' : '1px solid RGBA(12, 33, 52, 1)',
          }"
        >
          {{ item.projectName }}
        </div> -->
        <div :class="[item.projectStartStatus == 1 && item.projectStatus == 3 ? 'lister1': '','lister']">
          <div class="aleft">{{ item.projectName.length > 28 ? item.projectName.slice(0,28)+'...' : item.projectName }}</div>
          <div class="aRight" v-if="item.projectStartStatus == 1 && item.projectStatus == 3">
            已超期<img
              class="aImg"
              src="../../../assets/images/warn.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
    },
  },
  data() {
    return {
      list:[],
      activeItem: 0, 
      projectStatus: 1,
      tabList: [
        { name: "未开始", id: 0, flge: true, num: 0 },
        { name: "报名中", id: 1, flge: false, num: 0 },
        { name: "执行中", id: 2, flge: false, num: 0 },
        { name: "已完结", id: 3, flge: false, num: 0 },
      ],
      lister: [
        { text: "杭州市主城区食品安全服务宣传项目 ", ischange: false },
        { text: "乡镇(街道)社会组织服务中心建设项目 ", ischange: true },
        { text: "“给爸妈洗一次澡，修一次脚”老年人关爱项目 ", ischange: true },
        { text: "女性社会组织培育项目 ", ischange: true },
        { text: "手舞翼动，大爱无声”服务聋哑人项目 ", ischange: true },
        { text: "凯旋街道社会组织孵化项目 ", ischange: true },
        { text: "女性社区参与计划   ", ischange: false },
        { text: "互动咖啡馆项目 ", ischange: true },
        { text: "互动咖啡馆项目 ", ischange: true },
        // {text:'心理疏导及预防犯罪服务项目 ',ischange:true},
      ],
      lister1: [
        { text: "绿生活绿社区环保酵素制作项目 ", ischange: true },
        { text: "智能安防·防范有方”防诈骗宣传推广项目", ischange: true },
        { text: "青少年自护自救项目 ", ischange: true },
        { text: "独居孤寡老人关爱项目 ", ischange: false },
        { text: "夕阳无限好”老有所乐项目 ", ischange: true },
        { text: "未成年人心理辅导项目 ", ischange: false },
        { text: "关爱老人“1120”暖心行动志原服务项目", ischange: true },
        { text: "向阳花开”失独家庭关爱项目", ischange: true },
        { text: "公益大学残疾人关爱项目 ", ischange: true },
      ],
      lister2: [
        { text: "鲶鱼行动”垃圾分类项目 ", ischange: true },
        { text: "“全职妈妈”关爱暖心项目", ischange: true },
        { text: "学说杭州话，做新杭州人 ”外来人员教学项目 ", ischange: true },
        { text: "凯旋隔代教养成长项目", ischange: false },
        { text: "夕阳卫士，远离诈骗", ischange: true },
        { text: "“R立方+益”-环保手工创意项目", ischange: true },
        { text: "新时代生活新时尚--垃圾分类提质减量项目", ischange: false },
        {
          text: "爱心助餐项目 -关爱老人、解决老人就餐健康问题",
          ischange: true,
        },
        { text: "白领舒缓压力项目 ", ischange: true },
      ],
      lister3: [
        { text: "老顽童玩转智能手机课堂 ", ischange: true },
        { text: "家风家训", ischange: true },
        { text: "小候鸟陪伴计划", ischange: true },
        { text: "小候鸟漫游记", ischange: true },
        { text: "小候鸟趣学堂", ischange: true },
        { text: "银龄助梦 - 以公益温暖城市", ischange: true },
        { text: "银龄书法----楷书零基础班", ischange: true },
        { text: "致老干部-别开生面的庆生会", ischange: true },
        { text: "党务工作者沙龙", ischange: true },
      ],
      lister4: [
        { text: "杭州市主城区食品安全服务宣传项目 ", ischange: false },
        { text: "乡镇(街道)社会组织服务中心建设项目 ", ischange: true },
        { text: "“给爸妈洗一次澡，修一次脚”老年人关爱项目 ", ischange: true },
        { text: "女性社会组织培育项目 ", ischange: true },
        { text: "手舞翼动，大爱无声”服务聋哑人项目 ", ischange: true },
        { text: "凯旋街道社会组织孵化项目 ", ischange: true },
        { text: "女性社区参与计划   ", ischange: false },
        { text: "互动咖啡馆项目 ", ischange: true },
        { text: "互动咖啡馆项目 ", ischange: true },
        // {text:'心理疏导及预防犯罪服务项目 ',ischange:true},
      ],
    };
  },
  created() {
    // this.getList();
      this.activeItem = 1;    //选中Tab
      this.projectStatus = 2;  // 选中Tab对应的数据
      this.getList();
  },
  methods: {
    // 获取数据列表
    getList() {
      let url =
        this.$baseUrl + "/teamword/wechat/kyyProject/selectKyyProjectByGovId";
      let postData = {
        // page: 1,
        limit: 9,
        // street: this.id,
        projectStatus: this.projectStatus,
        // projectServiceType: this.select1,
        // projectCategory: this.select2,
      };
      this.postRequest(url, postData)
        .then((res) => {
          this.tabList[0].num = res.data.noStart;
          this.tabList[1].num = res.data.signUp;
          this.tabList[2].num = res.data.execution;
          this.tabList[3].num = res.data.knot;

          this.list = res.data.pageInfo.list;
          // console.log(res.data.pageInfo.list);
          // this.total = res.data.pageInfo.total;
          // this.tabList[0].num = res.data.all;
        })
        .catch(() => {});
    },
    // 去详情
    toprojectList(id) {
    //   //projectDetails?id=1410
      this.$router.push({
        path: "/projectDetails",
        query: 
          {id}
      })
    },
    // 切换Tab
    change(item) {
      this.activeItem = item.id;
      this.projectStatus = item.id+1;
      this.getList();
      // this.tabList.map((v, i) => {
      //   v.flge = false;
      //   if (item.id == i) {
      //     v.flge = true;
      //     this.projectStatus = i+1
      //   }
      // });
      // if (item.id == 0) {
      //   this.lister = this.lister4;
      // } else if (item.id == 1) {
      //   this.lister = [];
      //   this.lister = this.lister1;
      // } else if (item.id == 2) {
      //   this.lister = [];
      //   this.lister = this.lister2;
      // } else if (item.id == 3) {
      //   this.lister = [];
      //   this.lister = this.lister3;
      // }
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  position: relative;
  cursor: pointer;
  .out {
    position: absolute;
    top: -5px;
    // left: 10px;
    height: 36px;
    width: 541px;
    background: url("../../../assets/images/pageHome/box_title.png") center/100%
      100%;
    color: #fff;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    -webkit-pointer-events: none;
    -moz-pointer-events: none;
    -ms-pointer-events: none;
    -o-pointer-events: none;
    pointer-events: none;
    .title {
      position: absolute;
      top: 3px;
      left: 20px;
    }
  }
  //   div {
  //     position: absolute;
  //     top: 41%;
  //     left: 13%;
  //   }
  .tabList {
    // margin-left: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-top: 40px;
    z-index: 2;
    .taber {
      // height: 16px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #fff;
      text-align: center;
      // margin-right: 32px;
      // margin-left: 5px;
      padding-bottom: 11px;
    }
    .active {
      // height: 19px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #1293f0;
      border-bottom: 1px solid #1293f0;
      padding-bottom: 11px;
      text-align: center;
      // margin-right: 32px;
    }
  }
  .lister1{
    background: url("../../../assets/images/pageHome/warnBg.png") no-repeat
      center/100% 100%;
  }
  .lister {
    border-bottom: 1px solid RGBA(12, 33, 52, 1);
    padding-left: 2%;
    
    // width: 486px;
    width: 98%;
    height: 40px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #fff;
    line-height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .aRight {
      display: flex;
      align-items: center;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #0fffee;
      .aImg {
        width: 20px;
        height: 18px;
        margin-left: 10px;
      }
    }
  }
  .listers {
    padding-left: 2%;
    width: 98%;
    height: 40px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #fff;
    line-height: 40px;
    border-bottom: 1px solid rgba(11, 68, 102, 1);
  }
}
</style>
